// Lightweight fire-and-forget analytics client.
// No user identifiers are sent. Uses sendBeacon when available, otherwise fetch keepalive.

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const trackEvent = (type, payload = {}) => {
    try {
        const body = JSON.stringify({ type, ...payload });
        const endpoint = `${API_BASE}/events`;

        if (typeof navigator !== "undefined" && navigator.sendBeacon) {
            const blob = new Blob([body], { type: "application/json" });
            const ok = navigator.sendBeacon(endpoint, blob);
            if (ok) return;
        }

        // Fallback: non-blocking fetch
        fetch(endpoint, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body,
            keepalive: true,
        }).catch(() => {});
    } catch (_err) {
        // Intentionally swallow — analytics must never break the page
    }
};
